import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
 <wa-button
    size="small"
    appearance="plain"
    variant="neutral"
    aria-haspopup="true"
    aria-expanded="false"
    aria-controls="profile-dropdown"
    class="menu-btn"
    with-caret><slot name="buttonText"></slot></wa-button
  >
  <transition name="dropdown-fade">
    <ul class="dropdown-menu mt-1 closed">
      <slot></slot>
    </ul>
  </transition>
`

class NavHeaderPrimaryMenu extends HTMLElement {
  private handleOutsideClick: (event: MouseEvent) => void

  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    // Bind the handler so it can be removed later
    this.handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  connectedCallback() {
    console.log('NavHeaderPrimaryMenu connectedCallback', this)

    const shadow = this.shadowRoot
    if (shadow) {
      const btn = shadow.querySelector('wa-button')
      if (btn) {
        btn.addEventListener('click', () => {
          this.toggleMenu()
        })
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('mousedown', this.handleOutsideClick)
  }

  private _handleOutsideClick(event: MouseEvent) {
    // Check if the click is outside the component
    if (!this.contains(event.target as Node)) {
      this.closeMenu()
    }
  }

  private toggleMenu() {
    const panel = this.shadowRoot?.querySelector('ul')
    if (panel) {
      panel.classList.toggle('closed')

      if (!panel.classList.contains('closed')) {
        document.addEventListener('mousedown', this.handleOutsideClick)
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick)
      }
    }
  }

  private closeMenu() {
    const panel = this.shadowRoot?.querySelector('ul')
    if (panel && !panel.classList.contains('closed')) {
      panel.classList.toggle('closed')
    }
  }
}

if (!customElements.get('ts-navheader-primary-menu')) {
  customElements.define('ts-navheader-primary-menu', NavHeaderPrimaryMenu)
}
export { NavHeaderPrimaryMenu }
